<template>
    <div class="vue-tel-input" :class="[wrapperClasses, { disabled }]">
        <div
            v-click-outside="clickedOutside"
            class="dropdown"
            :class="{ open }"
            :tabindex="dropdownOptions && dropdownOptions.tabindex ? dropdownOptions.tabindex : 0"
            @keydown="keyboardNav"
            @keydown.esc="reset"
            @click="toggleDropdown">
            <span class="selection">
                <div v-if="enabledFlags" class="iti-flag" :class="activeCountry.iso2.toLowerCase()"></div>
                <span v-if="enabledCountryCode" class="country-code">+{{ activeCountry.dialCode }}</span>
                <slot name="arrow-icon" :open="open">
                    <span class="dropdown-arrow">{{ open ? "▲" : "▼" }}</span>
                </slot>
            </span>
            <ul v-show="open" ref="list">
                <li
                    v-for="(country, index) in sortedCountries"
                    :key="country.iso2 + (country.preferred ? '-preferred' : '')"
                    class="dropdown-item"
                    :class="getItemClass(index, country.iso2)"
                    @click="choose(country, true)"
                    @mousemove="selectedIndex = index">
                    <div v-if="enabledFlags" class="iti-flag" :class="country.iso2.toLowerCase()"></div>
                    <strong>{{ country.name }}</strong>
                    <span v-if="dropdownOptions && !dropdownOptions.disabledDialCode">+{{ country.dialCode }}</span>
                </li>
            </ul>
        </div>
        <input
            ref="input"
            v-model="phone"
            :class="inputClasses"
            :placeholder="parsedPlaceholder"
            :disabled="disabled"
            :required="required"
            :autocomplete="autocomplete"
            :autofocus="autofocus"
            :name="name"
            :id="inputId"
            :maxlength="maxLen"
            :tabindex="inputOptions && inputOptions.tabindex ? inputOptions.tabindex : 0"
            type="tel"
            @blur="onBlur"
            @input="onInput"
            @keyup.enter="onEnter"
            @keyup.space="onSpace" />
    </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";

// Recompile the legacy template so native v-model uses the Vue 3 event contract.
// Keep the installed library's formatting, country data, styles and public props/events.
export default {
    name: "VueTelInputCompat",
    extends: VueTelInput,
    __scopeId: VueTelInput._scopeId,
    methods: {
        choose(country, emitInput = false) {
            // Initialization passes an ISO code, while the dropdown passes a country object.
            const selectedCountry = typeof country === "string" ? this.findCountry(country) : country;
            return VueTelInput.methods.choose.call(this, selectedCountry, emitInput);
        },
    },
};
</script>
